<script>
	import { fade, fly } from 'svelte/transition'
	import { circOut } from 'svelte/easing'
	import { throttle } from 'throttle-debounce'
	import { set } from 'money-clip'

	export let coords
	export let shoudCacheCoords = false
	export let disableMovement = false

	if (!coords) {
		coords = {
			x: 0,
			y: -1,
		}
	}

	let height, width

	const updateCoords = throttle(99, true, e => {
		coords = {
			x: 0,
			y: -1,
		}
		if (disableMovement) {
			return
		}
		let { pageX, pageY } = e
		if (pageY < height) {
			coords = {
				x: (width / 2 - pageX) * 0.004,
				y: (height / 2 - pageY) * -0.004,
			}
		}
	})

	const cacheCoords = () => {
		if (shoudCacheCoords) {
			set('logoCoords', coords)
		}
	}
</script>

<svelte:window on:mousemove={updateCoords} on:beforeunload={cacheCoords} />

<div
	class="st-logo"
	bind:clientHeight={height}
	bind:clientWidth={width}
	in:fade={{ duration: 800, delay: 200 }}
	out:fade={{ duration: 400 }}>
	<svg viewBox="0 0 77.6 83.8" style="--ry: {coords.y}deg; --rx: {coords.x}deg">
		<path
			d="M36.7 75a28.1 28.1 0 01-5.7-9.1 29.2 29.2 0 01-1.9-10.5v-.1H5.2a37.2
			37.2 0 0035.2 25.2c1 0 2.1 0 3.1-.2a26.5 26.5 0 01-6.8-5.3"
			fill="#a7c6f3" />
		<path
			in:fly={{ x: 4, duration: 1400, delay: 200, easing: circOut }}
			d="M29.2 53.2A29.3 29.3 0 0133 40.5a29.8 29.8 0 0110.8-11 28.4 28.4 0
			0114.7-4 41.3 41.3 0 0110.5 1.4L73 28a11.9 11.9 0 001.4.2 37.2 37.2 0
			00-32.9-22L7 53.2z"
			fill="#a7c6f3" />
		<path
			in:fly={{ y: 4, duration: 1400, delay: 200, easing: circOut }}
			d="M73.2 32.6a19.2 19.2 0 00-7-4.1 24.4 24.4 0 00-7.6-1.3 20.4 20.4 0 00-9
			2 21.3 21.3 0 00-7.2 5.7 26.6 26.6 0 00-4.7 8.7 34.7 34.7 0 00-1.6 9.5
			16.1 16.1 0 004.3-.8 8 8 0 003.6-2.4 21 21 0 002.3-3.8h.6l-2.6 9.2H36a34.2
			34.2 0 001.7 10.3 25.2 25.2 0 004.7 8.6 21 21 0 006.7 5.2 37.2 37.2 0
			0028.5-36.1 37.6 37.6 0 00-.2-3.8 12.4 12.4 0 00-4.2-6.9"
			fill="#002d62" />
		<path
			in:fly={{ x: -4, duration: 1400, delay: 200, easing: circOut }}
			d="M3.3 43.3a37.3 37.3 0 00.3 5L34.1 6.7A37.2 37.2 0 003.3 43.3"
			fill="#002d62" />
		<path
			in:fly={{ x: 2, y: -4, duration: 1400, delay: 200, easing: circOut }}
			d="M41.5 6.2L45.2 1V0H0v10h.6a11.9 11.9 0 011.8-4.7 6.7 6.7 0 013.3-2.5
			16.4 16.4 0 015.4-.7h26.4l-3.4 4.6a37.6 37.6 0 016.3-.6h1.1"
			fill="#a7c6f3" />
		<path
			d="M45.8 81.4a29.1 29.1 0 0011.9 2.4A26 26 0 0068 82a43.8 43.8 0
			009.1-5.7v-2a23.8 23.8 0 01-9 5.6 29 29 0 01-9.3 1.7 21.8 21.8 0
			01-9.1-1.9l-.6-.3a37.2 37.2 0 01-5.6 1l2.3 1"
			fill="#a7c6f3" />
	</svg>
</div>
